import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import Tooltip from '@components/common/tooltip/main';
import { StandardSwitch, SwitchSize } from '@components/library/switch';

const ToggleContainer = ({ handleUpdate, param, state }) => {
  const { internal, require_share_identification_setting, restrict_shares_setting } = state;

  const toggleRowMap = {
    internal: {
      className: 'privacy-toggle',
      copy: bfTranslate('Make link private'),
      display: !restrict_shares_setting,
    },
    require_identification: {
      className: 'require-id-toggle',
      copy: bfTranslate('Require email address to access'),
      display: !restrict_shares_setting && !require_share_identification_setting && !internal,
    },
    view_only: {
      className: 'view-only-toggle',
      copy: bfTranslate('Disable download functionality (view only mode)'),
      display: BFG.currentUser.user_id !== '' && BFG.hasFeature('request_download_assets') && !BFG.viewOnlyCollection,
      // tooltipCopy: bfTranslate('When enabled, visitors may view assets, but must request access to download individual assets.'),
    },
    expires: {
      className: 'expires-toggle',
      copy: bfTranslate('Expire link'),
      display: true,
    },
    notifications_optin: {
      className: 'notifications-toggle',
      copy: bfTranslate('Notify me of updates to Share Link'),
      display: BFG.currentUser.user_id !== '',
    },
  };

  const { className, copy, display, tooltipCopy } = toggleRowMap[param];

  return (
    <CSSTransition
      in={display}
      timeout={300}
      unmountOnExit
    >
      {/* transition element can't have padding/margins - these properties can't transition,
          so extra parent container added here for JUST the transition,
          with padding/margin applied to the child element */}
      <div className="toggle-container-transition">
        <div className={`toggle-container ${className || ''} ${state[param] ? 'active' : ''}`}>
          <div className="copy-container">
            <h5>{copy}</h5>
            {tooltipCopy && (
              <Tooltip
                tooltipContent={tooltipCopy}
                tooltipId={param}
              >
                <span className="bff-tool-tip icon" />
              </Tooltip>
            )}
          </div>
          <StandardSwitch
            className={className}
            isChecked={state[param] || false}
            onChange={() => handleUpdate({ type: param })}
            size={SwitchSize.Large}
          />
        </div>
      </div>
    </CSSTransition>
  );
};

ToggleContainer.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  param: PropTypes.oneOf(['expires', 'internal', 'require_identification', 'view_only', 'notifications_optin']).isRequired,
  state: PropTypes.shape({
    internal: PropTypes.bool,
    require_share_identification_setting: PropTypes.bool,
    restrict_shares_setting: PropTypes.bool,
    notifications_optin: PropTypes.bool
  }).isRequired,
};

export default ToggleContainer;
